import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import * as React from "react";

import { FileRecord } from "@/shared/domain/files";

import { FileDetails } from "./FileDetails";

interface FileDetailsDialogProps {
  open: boolean;
  fileRecord: FileRecord | undefined;
  onClose: () => void;
}

export function FileDetailsDialog({
  open,
  fileRecord,
  onClose,
}: FileDetailsDialogProps) {
  const titleId = React.useId();
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      onClose={onClose}
      aria-labelledby={titleId}
    >
      <DialogTitle id={titleId}>File Details</DialogTitle>
      <DialogContent>
        {fileRecord && <FileDetails fileRecord={fileRecord} />}
      </DialogContent>
    </Dialog>
  );
}
